import styled from 'styled-components';

const PopoverStyle = styled.div`
  &&& {
    .ant-popover-inner {
      background: transparent;
      box-shadow: none;
      width: 470px;
      padding: 0;
      margin: 0;
  }
  .ant-popover-inner-content {
    padding: 0;
}
`;

export default PopoverStyle;
